import { createSelector } from '@reduxjs/toolkit';
import type { ViewState } from './slice';
import { name } from './slice';

const viewStateSelf = (state): ViewState => state[name];

export const getIsClientConfirmed = createSelector(
  viewStateSelf,
  (state) => state.isClientConfirmed,
);

export const getIsTyping = createSelector(
  viewStateSelf,
  (state) => state.isTyping,
);
